document.addEventListener('DOMContentLoaded', () => {
    const productCards = document.querySelectorAll('.byob-product-col');
    const countEl = document.getElementById('byob-selected-count');
    const progressEl = document.getElementById('byob-progress');
    const addBtn = document.getElementById('byob-add-to-cart');
    const comparePriceEl = document.getElementById('byob-compare-price');
    const finalPriceEl = document.getElementById('byob-final-price');
    const selectedImageBoxes = document.querySelectorAll('.byob-selected-image');
    const bundleTabs = document.querySelectorAll('.byob-bundle-tab');
    const imageContainer = document.querySelector('.byob-selection-image');
    let selectedVariants = [];
    const activeTab = document.querySelector('.byob-bundle-tab.active');
    let currentBundleCount = Number(activeTab.dataset.count);
    let currentBundlePrice = Number(activeTab.dataset.price);

    productCards.forEach(card => {
        if (card.dataset.available === 'false') {
            card.classList.add('sold-out');

            const btn = card.querySelector('.add-to-cart-byob');
            if (btn) {
                btn.innerText = 'Sold Out';
                btn.disabled = true;
            }
        }
    });

    function formatPrice(price) {
        return '₹' + Number(price).toLocaleString('en-IN');
    }

    // RESET SELECTIONS
    function resetSelections() {
        selectedVariants = [];
        productCards.forEach(card => {
            card.classList.remove('is-selected');
        });
        updateUI();
    }

    // UPDATE IMAGE BOXES
    function updateSelectedImages() {
        selectedImageBoxes.forEach((box, index) => {
            box.innerHTML = '';
            if (index < currentBundleCount) {
                box.style.display = 'flex';
            } else {
                box.style.display = 'none';
            }
        });

        selectedVariants.forEach((product, index) => {
            if (selectedImageBoxes[index]) {
                selectedImageBoxes[index].innerHTML = `
                    <div class="byob-selected-item">
                        <img src="${product.image}" alt="">
                        <button class="byob-remove-product" data-id="${product.id}">-</button>
                    </div>
                `;
            }
        });

        // COMPACT MODE
        if (currentBundleCount >= 6) {
            imageContainer.classList.add('compact');
        } else {
            imageContainer.classList.remove('compact');
        }
    }

    // UPDATE PRICES
    function updatePrices() {
        let totalComparePrice = 0;
        selectedVariants.forEach(product => {
            totalComparePrice += Number(product.comparePrice || 0);
        });

        const comparePrice = totalComparePrice / 100;
        let finalPrice = comparePrice;

        if (selectedVariants.length === currentBundleCount) {
            finalPrice = currentBundlePrice;
        }

        comparePriceEl.innerHTML = `
            <span style="text-decoration: line-through;">
                ${formatPrice(comparePrice)}
            </span>
        `;

        finalPriceEl.innerHTML = `
            <span>${formatPrice(finalPrice)}</span>
        `;
    }

    // UPDATE UI
    function updateUI() {
        countEl.textContent = selectedVariants.length;
        progressEl.style.width = ((selectedVariants.length / currentBundleCount) * 100) + '%';
        addBtn.disabled = selectedVariants.length !== currentBundleCount;

        document.querySelector('.byob-selection-status').innerHTML = `
            <span id="byob-selected-count">
                ${selectedVariants.length}
            </span>/${currentBundleCount} Selected
        `;

        updateSelectedImages();

        document.querySelectorAll('.byob-remove-product').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const variantId = btn.dataset.id;

                // REMOVE FROM ARRAY
                selectedVariants = selectedVariants.filter(
                    item => item.id !== variantId
                );

                // REMOVE ACTIVE CLASS FROM PRODUCT CARD
                document.querySelectorAll('.byob-product-col').forEach(card => {
                    if (card.dataset.variantId === variantId) {
                        card.classList.remove('is-selected');
                        const cartBtn = card.querySelector('.add-to-cart-byob');
                        if (cartBtn) {
                            cartBtn.innerText = 'Add to Cart';
                        }
                    }
                });
                updateUI();
            });
        });
        updatePrices();
    }

    // BUNDLE TAB CLICK
    bundleTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            bundleTabs.forEach(btn =>
                btn.classList.remove('active')
            );

            tab.classList.add('active');
            currentBundleCount = Number(tab.dataset.count);
            currentBundlePrice = Number(tab.dataset.price);

            resetSelections();
        });
    });

    // PRODUCT CLICK
    productCards.forEach(card => {
        card.addEventListener('click', () => {
            if(card.dataset.available === 'false'){
                return;
            }
            const variantId = card.dataset.variantId;
            const image = card.dataset.image;
            const price = Number(card.dataset.price);
            const comparePrice = Number(card.dataset.comparePrice);

            if (!variantId) {
                alert('Variant ID Missing');
                return;
            }

            // REMOVE
            const btn = card.querySelector('.add-to-cart-byob');
            if (card.classList.contains('is-selected')) {
                card.classList.remove('is-selected');
                btn.innerText = 'Add to Cart';
                selectedVariants = selectedVariants.filter(
                    item => item.id !== variantId
                );
            } else {
                // LIMIT
                if (selectedVariants.length >= currentBundleCount) {
                    alert(`You can select only ${currentBundleCount} products`);
                    return;
                }

                card.classList.add('is-selected');
                btn.innerText = 'Remove From Cart';
                selectedVariants.push({
                    id: variantId,
                    image,
                    price,
                    comparePrice
                });

                // CONFETTI
                if (selectedVariants.length === currentBundleCount) {
                    confetti({
                        particleCount: 150,
                        angle: 60,
                        spread: 80,
                        origin: { x: 0, y: 0.7 }
                    });

                    confetti({
                        particleCount: 150,
                        angle: 120,
                        spread: 80,
                        origin: { x: 1, y: 0.7 }
                    });
                }
            }
            updateUI();
        });
    });

    // REFRESH CART UI
    async function refreshCartUI() {
        try {
            await fetch('/cart.js');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', {
                    bubbles: true
                })
            );

            const cartDrawer = document.querySelector('cart-drawer');

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                const response = await fetch('/cart.js');
                const cart = await response.json();
                cartDrawer.renderContents(cart);
            }
        } catch (e) {
            console.log('Cart Refresh Failed', e);
        }
    }

    // WAIT FOR GOKWIK
    async function waitForGoKwik() {
        return new Promise(resolve => {
            let tries = 0;
            const interval = setInterval(() => {
                tries++;
                if (window.Gokwik || window.gokwikSdk) {
                    clearInterval(interval);
                    resolve(true);
                }

                const gokwikBtn = document.querySelector('#gokwik-buy-now') || document.querySelector('.gokwik-checkout') || document.querySelector('[class*="gokwik"]') || document.querySelector('[id*="gokwik"]');

                if (gokwikBtn) {
                    clearInterval(interval);
                    resolve(true);
                }

                if (tries > 30) {
                    clearInterval(interval);
                    resolve(false);
                }
            }, 1000);
        });
    }

    // OPEN GOKWIK
    async function openGoKwik() {
        await refreshCartUI();
        await new Promise(resolve =>
            setTimeout(resolve, 3000)
        );
        try {
            if (window.Gokwik && typeof window.Gokwik.checkout === 'function') {
                window.Gokwik.checkout();
                return true;
            }
        } catch (e) {
            console.log(e);
        }

        try {
            if (window.Gokwik && typeof window.Gokwik.openCheckout === 'function') {
                window.Gokwik.openCheckout();
                return true;
            }
        } catch (e) {
            console.log(e);
        }
        const gokwikBtn = document.querySelector('#gokwik-buy-now') || document.querySelector('.gokwik-checkout button') || document.querySelector('.gokwik-checkout') || document.querySelector('[class*="gokwik"] button') || document.querySelector('[class*="gokwik"]') || document.querySelector('[id*="gokwik"]');

        if (gokwikBtn) {
            gokwikBtn.removeAttribute('disabled');
            gokwikBtn.click();
            return true;
        }
        return false;
    }

    // ADD TO CART
    addBtn.addEventListener('click', async () => {
        if (selectedVariants.length !== currentBundleCount) {
            alert(`Please select ${currentBundleCount} products`);
            return;
        }
        try {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Preparing Checkout...';

            // CHECK CART
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();

            // CLEAR CART
            if (cartData.items && cartData.items.length > 0) {
                await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });
                await new Promise(resolve =>
                    setTimeout(resolve, 1500)
                );
            }

            addBtn.innerHTML = 'Adding Products...';
            const items = selectedVariants.map(item => ({
                id: Number(item.id),
                quantity: 1
            }));

            // ADD ITEMS
            const response =
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        items
                    })
                });

            if (!response.ok) {
                throw new Error('Add To Cart Failed');
            }

            await new Promise(resolve => setTimeout(resolve, 1500));
            await refreshCartUI();

            window.history.pushState({}, '', window.location.pathname);

            await new Promise(resolve => setTimeout(resolve, 3000));
            await waitForGoKwik();

            addBtn.innerHTML = 'Opening Checkout...';
            const opened = await openGoKwik();

            if (!opened) {
                alert('Unable to open GoKwik checkout');
            }

            setTimeout(() => {
                addBtn.disabled = false;
                addBtn.innerHTML = 'Add to Cart';
            }, 3000);

        } catch (error) {
            console.error(error);
            alert('Something went wrong');
            addBtn.disabled = false;
            addBtn.innerHTML = 'Add to Cart';
        }
    });

    document.addEventListener('submit', function(e) {
        const form = e.target;
        if (form.action && ( form.action.includes('/cart') || form.action.includes('/checkout'))) {
            e.preventDefault();
        }
    });

    const originalAssign = window.location.assign;
    window.location.assign = function(url) {
        if ( url.includes('/cart') || url.includes('/checkout')) {
            return;
        }

        originalAssign.call(window.location, url);
    };

    const searchInput = document.querySelector('.byob-search');
    const productContainer = document.querySelector('.byob-main');

    document.querySelectorAll('.byob-product-col').forEach((card,index)=>{
        card.dataset.originalIndex = index;
    });

    function debounce(func, delay = 300) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this,args);
            },delay);
        };
    }

    const handleSearch = debounce((searchValue)=>{
        const cards = [...document.querySelectorAll('.byob-product-col')];
        const keyword = searchValue.toLowerCase().trim();
        if(!keyword){
            cards.sort((a,b)=>{
                return (Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));
            });
            cards.forEach(card=>{
                card.style.display='';
                productContainer.appendChild(card);
            });
            const noResult =document.querySelector('.search-empty');
            if(noResult){
                noResult.remove();
            }
            return;
        }
        const matched = [];
        const unmatched = [];
        cards.forEach(card=>{
            const title = card.querySelector('.byob-product-title')?.innerText.toLowerCase() || '';
            if(title.includes(keyword)){
                matched.push(card);
            }else{
                unmatched.push(card);
            }
        });

        const oldMessage = document.querySelector('.search-empty');
            if(oldMessage){
                oldMessage.remove();
            }

            [...matched,...unmatched].forEach(card=>{
                productContainer.appendChild(card);
            });

            matched.forEach(card=>{
                card.style.display='';
            });

            unmatched.forEach(card=>{
                card.style.display='';
            });

            if(matched.length === 0){
                const empty = document.createElement('p');
                empty.className = 'search-empty';
                empty.innerText = 'No products found';
                productContainer.appendChild(empty);
            }
        },300
    );

    if(searchInput){
        searchInput.addEventListener('input', function(e){
            handleSearch(e.target.value);
        });
    }

    const showMoreBtn = document.getElementById('byob-show-more');
    let visibleCount = 20;
    const loadCount = 20;

    productCards.forEach((card,index)=>{
        if(index >= visibleCount){
            card.classList.add('hidden-product');
        }
    });

    function loadProducts(){
        const hiddenProducts = document.querySelectorAll(
            '.byob-product-col.hidden-product'
        );
        for(let i=0;i<loadCount;i++){
            if(hiddenProducts[i]){
                hiddenProducts[i].classList.remove(
                    'hidden-product'
                );
            }
        }

        const remainingProducts = document.querySelectorAll(
            '.byob-product-col.hidden-product'
        );

        if(!remainingProducts.length && showMoreBtn){
            showMoreBtn.style.display='none';
        }
    }

    if(showMoreBtn){
        showMoreBtn.addEventListener('click', loadProducts);
    }

    window.addEventListener('scroll', ()=>{
        if(!showMoreBtn) return;

        const rect = showMoreBtn.getBoundingClientRect();
        if(rect.top <= window.innerHeight + 100 && showMoreBtn.style.display !== 'none'){
            loadProducts();
        }
    });

    updateUI();
});